import React from 'react'
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageSection from "../../components/layout/PageSection";
import PageTitle from "../../components/layout/PageTitle";
import PageContainer from "../../components/layout/PageContainer";
import SinAtencionForm from "./SinAtencionForm";


const SinAtencionNew = () => {
  const navigate = useNavigate()

  const onCreate = async (user) => {
    await axios.post(Apis.PROD + '/fecha-sin-atencion/new',user)
      .then(res => {
        successToast("Fecha sin atención creada correctamente")
        navigate('/sin-atencion')
      })
      .catch(err => {
        errorToast(err.response.data.message,6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Fechas sin atención' onClick={() => navigate('/sin-atencion')}/>
        <PageTitle title={'Fecha sin atención nueva'}/>
      </PageSection>

      <PageSection>
        <SinAtencionForm value={{}} onSubmit={(sinAtencion) => onCreate(sinAtencion)}/>
      </PageSection>
    </PageContainer>
  )
}

export default SinAtencionNew;
